export default __webpack_public_path__ + "static/media/souncloud-original.44fe90fd.svg";